'use strict';

$ = jQuery;

var modelTechnicalCharacteristics = $('.jc-model-technical-characteristics');
var modelUrl = modelTechnicalCharacteristics.data('model-url');
var modelVersions = modelTechnicalCharacteristics.find('.jc-model-versions');

var tcPrice = modelTechnicalCharacteristics.find('.price');
var tcEngine = modelTechnicalCharacteristics.find('.engine');
var tcTransmission = modelTechnicalCharacteristics.find('.transmission');
var tcPower = modelTechnicalCharacteristics.find('.power');
var tcTorque = modelTechnicalCharacteristics.find('.torque');
var tcLength = modelTechnicalCharacteristics.find('.length');
var tcWidth = modelTechnicalCharacteristics.find('.width');
var tcHeight = modelTechnicalCharacteristics.find('.heigth');
var tcLengthBetweenAxis = modelTechnicalCharacteristics.find('.length-between-axis');
var tcTrunk = modelTechnicalCharacteristics.find('.trunk');
var tcTopSpeed = modelTechnicalCharacteristics.find('.top-speed');
var tcAcceleration = modelTechnicalCharacteristics.find('.acceleration');
var tcUrbanConsumption = modelTechnicalCharacteristics.find('.urban-consumption');
var tcRoadConsumption = modelTechnicalCharacteristics.find('.road-consumption');

modelVersions.change(function () {
  var version = $(this).val();
  window.history.replaceState(null, "", modelUrl + version + '/');
  var versionSelected = $(this).find(':selected');
  tcPrice.text(versionSelected.data('price'));
  tcEngine.text(versionSelected.data('engine'));
  tcTransmission.text(versionSelected.data('transmission'));
  tcPower.text(versionSelected.data('power'));
  tcTorque.text(versionSelected.data('torque'));
  tcLength.text(versionSelected.data('length'));
  tcWidth.text(versionSelected.data('width'));
  tcHeight.text(versionSelected.data('heigth'));
  tcLengthBetweenAxis.text(versionSelected.data('length-between-axis'));
  tcTrunk.text(versionSelected.data('trunk'));
  tcTopSpeed.text(versionSelected.data('top-speed'));
  tcAcceleration.text(versionSelected.data('acceleration'));
  tcUrbanConsumption.text(versionSelected.data('urban-consumption'));
  tcRoadConsumption.text(versionSelected.data('road-consumption'));
});